<div class="mat-h4">
  <mat-progress-bar [mode]="'indeterminate'" *ngIf="loading"></mat-progress-bar>
  <p>Le lien est déterminé à partir du <strong>nom du formulaire</strong>, il doit être unique pour tous les formulaires de l'application.</p>
  <p>Nous vous proposons ce lien, vous pouvez l'éditer si besoin grâce à l'icone d'édition :</p>
  <div class=" mat-elevation-z2">
    <span>{{formSvc.formUrlDemandeurBase()}}<app-edit-slug-in-place *ngIf="form" [form]="form" (slugSend)="onSlugSend($event)" (editInPlace)="onEditInPlace($event)"></app-edit-slug-in-place></span>
  </div>
</div>
